/**
 * Funcion que retorna la expresion regular para la validacion del correo electronico
 */
export const getPatterEmail = () => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
};

//Convertir un numero a formato moneda
export const convertCurrencyNumber = (number) => {
  return new Intl.NumberFormat("de-DE").format(number);
};

//Funcion para convertir blob a File
export function blobToFile(blob, fileName) {
  blob.lastModifiedDate = new Date();
  blob.name = fileName;
  return blob;
}

//Funcion que retorna la fecha actual
export const getActualDate = () => {
  let dateActual = new Date();
  let year = dateActual.getFullYear();
  let month = (dateActual.getMonth() + 1).toString().padStart(2, "0");
  var day = dateActual.getDate().toString().padStart(2, "0");
  return year + "-" + month + "-" + day;
};

//Funcion para convertir la primera palabra de un string a Mayuscula
export const convertString = (value) => {
  const splitName = value.split(" ");
  const finalString = splitName.map((word) => {
    return word !== "" ? word[0].toUpperCase() + word.slice(1).toLowerCase() : "";
  });
  return finalString.join(" ");
};

/**
 * Funcion para validar si una fecha es menor o mayor a la fecha actual
 * Retorna true si es mayor y false si es menor
 * @param string date
 * @returns boolean
 */
export const validateDate = (date) => {
  let dateValidate = new Date(date);
  let today = new Date();
  if (dateValidate >= today) {
    return true;
  } else {
    return false;
  }
};

/**
 * Funcion para consultar el id del archivo cargado a genio dentro de las cookies
 */
export function getIdByCookie(name) {
  const value = document.cookie.split("; ").find((row) => row.startsWith(name + "="));
  return value ? value.split("=")[1] : "";
}

/**
 * Funcion para limpiar el valor de una cookie
 */
export function clearValueCookie(name) {
  document.cookie = `${name}=""; path=/; domain=.repremundo.com.co; Secure; SameSite=Lax`;
}

/**
 * Funcion para validar si el momento actual esta dentro del horario laboral
 */
export function isWorkingDay(actualDate = new Date()) {
  const day = actualDate.getDay();
  const hour = actualDate.getHours();
  const minutes = actualDate.getMinutes();
  const totalMinutes = hour * 60 + minutes;
  if (day >= 1 && day <= 5) {
    // Lunes a Viernes 8 a 17
    // return totalMinutes >= 8 * 60 && totalMinutes < 17 * 60;
    return true
  } else if (day === 6) {
    // Sabado 8 a 12
    return totalMinutes >= 8 * 60 && totalMinutes < 12 * 60;
  }
  return false;
}
